var map = {
	"./action/bookmark.svg": "463c",
	"./action/delete.svg": "d754",
	"./action/download.svg": "d35d",
	"./action/edit.svg": "b1b1",
	"./action/email.svg": "fa1c",
	"./action/error.svg": "1149",
	"./action/eye_white.svg": "c58f",
	"./action/image.svg": "ea7c",
	"./add.svg": "eef4",
	"./alert.svg": "6c40",
	"./analytics.svg": "732d",
	"./arrows/keyboard-arrow-bottom.svg": "3f7c",
	"./arrows/keyboard-arrow-top.svg": "c83c",
	"./business.svg": "83b9",
	"./cancel.svg": "f687",
	"./cards/Proveedores.svg": "c717",
	"./cards/offices.svg": "2176",
	"./cards/presupuesto.svg": "3d0f",
	"./close.svg": "bf37",
	"./dashboard.svg": "57a8",
	"./eye.svg": "83a4",
	"./file.svg": "46c7",
	"./help.svg": "6a22",
	"./home.svg": "86e6",
	"./logo.png": "cf05",
	"./logo_bn.png": "b6fc",
	"./navigation-menu-1.svg": "b5ec",
	"./next.svg": "b2f3",
	"./prev.svg": "9336",
	"./products-briefcase.svg": "d104",
	"./project.svg": "52c2",
	"./search.svg": "51f2",
	"./smiley.svg": "f8b0",
	"./team.svg": "8316",
	"./upload.svg": "c118",
	"./user.svg": "0f62",
	"./warning.svg": "afb7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";